import { gql } from "@apollo/client";
import {
  MARKETING_TILES_FRAGMENT,
  MULTIPLE_PRODUCT_CARD_FRAGMENT,
  PRODUCT_CARDS_FRAGMENT,
  SINGULAR_PRODUCT_CARD_FRAGMENT
} from "@shared/graphql.fragments";

export const GET_PLP = gql`
  query getPlp(
    $categoryUrlPath: String!
    $filters: [String!]
    $pagination: PaginationInput
    $sort: SortOptionEnum
    $isTypicalJourney: Boolean
    $marketingTilesPath: String!
    $branchName: String!
    $staged: Boolean
  ) {
    getPlp(
      categoryUrlPath: $categoryUrlPath
      filters: $filters
      pagination: $pagination
      sort: $sort
      isTypicalJourney: $isTypicalJourney
    ) {
      marketingTiles(
        categoryPath: $marketingTilesPath
        branchName: $branchName
        preview: $staged
      ) {
        ...MarketingTilesFragment
      }
      category {
        title
        description
        metaTitle
        metaDescription
        hreflangs {
          locale
          slug
        }
        variantCount
        productCount
        filters {
          slug
          label
          items {
            label
            slug
            subItems {
              label
              count
              slug
            }
          }
        }
        relatedCategories {
          title
          href
        }
        seo {
          id
          page
          terms
          noindex
          nofollow
          canonical
          pageHeaderDescription
          pageFooterDescription
        }
      }
      productCards {
        ...ProductCardsFragment
      }
    }
  }
  ${MARKETING_TILES_FRAGMENT}
  ${PRODUCT_CARDS_FRAGMENT}
`;

export const SEARCH_SUGGESTION_QUERY = gql`
  query searchProductsSuggestions(
    $term: String!
    $useGuestPrice: Boolean
    $isTypicalJourney: Boolean
  ) {
    searchProducts(
      term: $term
      useGuestPrice: $useGuestPrice
      isTypicalJourney: $isTypicalJourney
    ) {
      searchSuggestions(
        term: $term
        useGuestPrice: $useGuestPrice
        isTypicalJourney: $isTypicalJourney
      ) {
        ... on SearchResults {
          products {
            ...MultipleProductCardFragment
            ...SingularProductCardFragment
          }
        }
      }
    }
  }
  ${MULTIPLE_PRODUCT_CARD_FRAGMENT}
  ${SINGULAR_PRODUCT_CARD_FRAGMENT}
`;
